export default __webpack_public_path__ + "static/toolscoverspa-7f4dbd0e4bafed2adda6f46a389ba16f.png";